// extracted by mini-css-extract-plugin
export default {"star-ratings":"WVj_6M"};